module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAABQElEQVQoU52Sv0oDQRCHf7O3wcarkqu0SYqQ5hYvlYqFMYWd+gymDPgSeqC+Q1q1U/QB8gSBeMuhFlHRwiagjSLJuiOnXrjCf8lWw7Ifs7+Zj5A5cRzPWWu3ANSJaBbAM4Bza+2R67qtYrH4mj6npGi32zKfz+8IIRrMvDcYDE56vd5NqVSallLOSymbzFzO5XLrlUrlKmE+QK31PoBlZl5VSj1mf5HWWusGEW0Ph8PFIAhuqdvtLjmOc2iM8YMgePoOSu/iOA6ttb7v+2sURdEBgEgptfsblEYqFAr3AFZIa/1gjFlI2v8FfsU6FkKcJuBbv9+fqtVq5p9gC8DFRB0BnI2d0fO8O2aujzVVrXUI4HOqE+8xY04ohNhMzalWq9edTsdNzHEcpwmgzMwbSqnLkTmZBY9cBTBDRC8/ufoOHxy2+uf06TAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/pitch-on-no.png
// module id = 6++g
// module chunks = 0